import React from "react";
import "../RateManagement/style.css";
import Border from "../../components/border";

export const HotelDetails = ({ hotelDetails, isBorder }) => {
  return (
    <>
      <div className="hotel-details">
        <div>
          <span>Hotel Name :</span> {hotelDetails?.name}
        </div>
        <div>
          <span>Country :</span> {hotelDetails?.country?.name}
        </div>
        <div>
          <span>State :</span> {hotelDetails?.state?.name}
        </div>
        <div>
          <span>City :</span> {hotelDetails?.city?.name}
        </div>
      </div>
      {isBorder && <Border />}
    </>
  );
};
